import { CanDeactivateFn } from '@angular/router';

export interface CanComponentDeactivate {
  canDeactivate(): boolean | Promise<boolean>;
}

export const CanDeactivateGuard: CanDeactivateFn<CanComponentDeactivate> = (component: CanComponentDeactivate) => {
  if (component?.canDeactivate) {
    const result = component.canDeactivate();
    // 确保返回值被正确处理
    if (result instanceof Promise) {
      return result;
    }
    return Promise.resolve(result);
  }
  return true;
};
